export default __webpack_public_path__ + "static/media/Rubik-BoldItalic.fd2b84fe.ttf";